export const iconFontAwesomeCommunicationHandsAslInterpreting = (
	<i className="fa-solid fa-hands-asl-interpreting"></i>
);
